import React, { useEffect } from 'react';

export default function TermsAndConditions() {
  useEffect(() => {
    // Load Termly.io embed script
    if (document.getElementById('termly-jssdk')) return;
    
    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  }, []);

  return (
    <div className="min-h-screen bg-theme-bg py-8 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-6 sm:p-8">
        <h1 className="text-3xl font-bold text-theme-primary mb-6">Terms and Conditions</h1>
        <div className="prose max-w-none">
          <div name="termly-embed" data-id="6c2d99a2-2053-45b6-b4f1-6adee1ff2f56" data-type="iframe"></div>
        </div>
      </div>
    </div>
  );
}

